import { Image } from "react-bootstrap";
import { AlertCircleIcon, CompleteArrow, EditIcon } from "src/assets";
import {
  FormikGroup,
  GetGroupExtraInfo,
} from "src/types/networking/terminals/group.types";
import { StrongTranslationString } from "src/ui/widgets/mixed-translation-string/mixed-translation-string";
import { useGroupList } from "./group-list.hook";
import { Accordion, CollapsiblePanel } from "src/ui/widgets";
import { FileUploadedStatus } from "src/types";

export const GroupList = ({
  groupInfo,
  onModifyElement,
}: {
  groupInfo: FormikGroup;
  onModifyElement: (index: number) => {};
}) => {
  const {
    fixedList,
    collapsibleList,
    visibileItems,
    listIsExpanded,
    t,
    setVisibleItems,
    setListIsExpanded,
    showModifyButton,
  } = useGroupList({ groupInfo });

  const { filesStatus, group } = groupInfo;

  if (!filesStatus) return <></>;

  const GroupListHeader = (
    <div className="d-flex align-items-center">
      {filesStatus === FileUploadedStatus.OK ? (
        <div>
          <div className="font-20-bold c-secondary align-items-center flex-row d-flex mb-1">
            <div className="text-uppercase">
              {t("entry_group_step_2.insureds")}
            </div>
          </div>
          <div className="font-14 d-none d-md-block">
            {t("entry_group_step_2.visible_insureds", {
              visibileItems,
              total: group.length,
            })}
          </div>
          <div className="font-14 d-block d-md-none">
            {t("entry_group_step_2.visualize_insureds")}
          </div>
        </div>
      ) : (
        <div>
          <div className="font-20-bold c-error align-items-center flex-row d-flex mb-1">
            <Image
              src={AlertCircleIcon}
              width={24}
              height={24}
              className="filter-F34747 me-2"
            />
            <div className="text-uppercase">{t("commons.error_label")}</div>
          </div>
          <div className="font-14">
            <StrongTranslationString
              i18nKey="entry_group_step_2.group_number"
              param={{
                insured_number: group?.length,
              }}
              count={group?.length}
              color="#000000"
            />
          </div>
        </div>
      )}
    </div>
  );

  const GroupListDesktop = ({ list }: { list: GetGroupExtraInfo }) => (
    <>
      {list?.map((groupMember, index) => {
        return (
          <div key={index}>
            <div className="col-md-12 d-flex align-items-center">
              <div className="group-insured-row-text col-4">
                {groupMember?.assicurato.nome} {groupMember?.assicurato.cognome}
              </div>
              <div className="group-insured-row-text col-4">
                {groupMember?.assicurato.luogoNascita &&
                groupMember?.assicurato.dataNascita ? (
                  <div>
                    {groupMember?.assicurato.luogoNascita},{" "}
                    {groupMember?.assicurato.dataNascita}
                  </div>
                ) : (
                  <div>-</div>
                )}
              </div>
              <div
                className={`group-insured-row-text col-${
                  filesStatus != FileUploadedStatus.OK ? "3" : "4"
                }`}
              >
                {groupMember?.assicurato.codiceFiscale ? (
                  <div>{groupMember?.assicurato.codiceFiscale}</div>
                ) : (
                  <div>-</div>
                )}
              </div>
              {showModifyButton({ errors: groupMember.errors }) && (
                <div
                  className="col-1 d-flex align-items-center justify-content-center cursor-pointer"
                  onClick={() => onModifyElement(index)}
                >
                  <div className="text-uppercase group-insured-row-text fw-bold">
                    {t("commons.modify_label")}
                  </div>
                  <Image
                    src={EditIcon}
                    width={20}
                    height={20}
                    className="ms-1 filter-00686F"
                  />
                </div>
              )}
            </div>
            <div className="mt-2 mb-2 border-top" />
          </div>
        );
      })}
    </>
  );

  const GroupListMobile = ({ list }: { list: GetGroupExtraInfo }) => {
    return (
      <>
        {list?.map((groupMember, index) => (
          <div key={index}>
            <div className="font-14-semibold col-md-4 text-uppercase c-7f7f7f">
              {t("entry_group_step_2.group_column_1")}
            </div>
            <div className="group-insured-row-text col-md-4">
              {groupMember?.assicurato.nome} {groupMember?.assicurato.cognome}
            </div>
            <div className="font-14-semibold col-md-3 text-uppercase c-7f7f7f mt-2">
              {t("entry_group_step_2.group_column_2")}
            </div>
            <div className="group-insured-row-text col-md-3">
              {groupMember?.assicurato.luogoNascita &&
              groupMember?.assicurato.dataNascita ? (
                <div>
                  {groupMember?.assicurato.luogoNascita},{" "}
                  {groupMember?.assicurato.dataNascita}
                </div>
              ) : (
                <div>-</div>
              )}
            </div>
            <div className="font-14-semibold col-md-3 text-uppercase c-7f7f7f mt-2">
              {t("entry_group_step_2.group_column_3")}
            </div>
            <div className="group-insured-row-text col-md-3">
              {groupMember?.assicurato.codiceFiscale ? (
                <div>{groupMember?.assicurato.codiceFiscale}</div>
              ) : (
                <div>-</div>
              )}
            </div>
            {groupMember?.errors && (
              <div
                className="col-md-2 d-flex align-items-center justify-content-center cursor-pointer mt-3"
                onClick={() => onModifyElement(index)}
              >
                <div className="text-uppercase group-insured-row-text-bold">
                  {t("commons.modify_label")}
                </div>
                <Image
                  src={EditIcon}
                  width={20}
                  height={20}
                  className="ms-1 filter-00686F"
                />
              </div>
            )}

            <div
              className={`mt-4 mb-4 ${
                group?.length != index + 1 && "border-top"
              }`}
            />
          </div>
        ))}
      </>
    );
  };

  const SuccessGroupListContainerMobile = (
    <div className="col-12 d-block d-md-none">
      <Accordion
        classesIcon="filter-00686F"
        classes="group-list-container d-flex flex-column"
        icon={CompleteArrow}
        classesHead=" d-flex flex-row justify-content-between align-items-center col-12"
        head={GroupListHeader}
      >
        <div className="mt-4">
          <GroupListMobile list={group} />
        </div>
      </Accordion>
    </div>
  );

  const SuccessGroupListContainerDesktop = (
    <div className="d-flex align-items-center justify-content-center group-list-container d-none d-md-block">
      <div className="col-md-12">
        <CollapsiblePanel
          defaultExpanded={false}
          head={GroupListHeader}
          bottom={
            listIsExpanded ? (
              <> {t("entry_group_step_2.show_less")}</>
            ) : (
              <> {t("entry_group_step_2.show_all")}</>
            )
          }
          classesBottom="mt-4 d-flex justify-content-end flex-nowrap"
          iconBottom={CompleteArrow}
          classesIconBottom="ms-2 filter-00686F"
          arrowVersus="bottom"
          classes="d-flex flex-column"
          classesHead="d-flex flex-row justify-content-between align-items-center mb-4"
          fixedChildren={
            <>
              <div className="col-md-12 d-flex align-items-center mb-4">
                <div className="font-14-semibold col-4 text-uppercase c-7f7f7f">
                  {t("entry_group_step_2.group_column_1")}
                </div>
                <div className="font-14-semibold col-4 text-uppercase c-7f7f7f">
                  {t("entry_group_step_2.group_column_2")}
                </div>
                <div className="font-14-semibold col-4 text-uppercase c-7f7f7f">
                  {t("entry_group_step_2.group_column_3")}
                </div>

                <div className="col-md-2" />
              </div>
              <GroupListDesktop list={fixedList} />
            </>
          }
          collapsibleChildren={<GroupListDesktop list={collapsibleList} />}
          onToggle={(expanded) => {
            setListIsExpanded(expanded);
            setVisibleItems(expanded ? group.length : fixedList.length);
          }}
        ></CollapsiblePanel>
      </div>
    </div>
  );

  const ErrorGroupListContainerMobile = (
    <div className="d-flex align-items-center justify-content-center group-list-container d-block d-md-none">
      <div className="col-12">
        {GroupListHeader}
        <>
          <div className="mt-3 mb-3 border-top" />
          <GroupListMobile list={group} />
        </>
      </div>
    </div>
  );

  const ErrorGroupListContainerDesktop = (
    <div className="d-flex align-items-center justify-content-center group-list-container d-none d-md-block">
      <div className="col-md-12">
        {GroupListHeader}

        <>
          <div className="mt-3 mb-3 border-top" />
          <div className="col-md-12 d-flex align-items-center mb-4">
            <div className="font-14-semibold col-4 text-uppercase c-7f7f7f">
              {t("entry_group_step_2.group_column_1")}
            </div>
            <div className="font-14-semibold col-4 text-uppercase c-7f7f7f">
              {t("entry_group_step_2.group_column_2")}
            </div>
            <div
              className={`font-14-semibold col-4 text-uppercase c-7f7f7f col-${
                filesStatus != FileUploadedStatus.OK ? "3" : "4"
              }`}
            >
              {t("entry_group_step_2.group_column_3")}
            </div>

            {filesStatus != FileUploadedStatus.OK && (
              <div className="col-1"></div>
            )}
          </div>
          <GroupListDesktop list={group} />
        </>
      </div>
    </div>
  );

  return (
    <>
      {filesStatus === FileUploadedStatus.OK ? (
        <>
          {SuccessGroupListContainerDesktop}
          {SuccessGroupListContainerMobile}
        </>
      ) : (
        <>
          {ErrorGroupListContainerDesktop}
          {ErrorGroupListContainerMobile}
        </>
      )}
    </>
  );
};
